const theme = {
  palette: {
    primary: {
      light: '#757ce8',
      main: '#2942ce',
      dark: '#002884',
      contrastText: '#fff',
    },
    secondary: {
      light: '#ff7961',
      main: '#f44336',
      dark: '#ba000d',
      contrastText: '#000',
    },
  },
  typography: {
    useNextVariants: true,
  },
};

export default theme;
